$(document).ready(() => {
    // Desktop Size
    const moveCarousels = function (i, firstId, secondId) {
        $(firstId).carousel(i);
        $(secondId).carousel(i);
    };

    const setActiveDiv = function (slides, activeIndex) {
        const l = slides.length;
        // Remove active class from all text div
        for (let j = 0; j < l; j++) {
            $(`#${slides[j].div_id}`).removeClass('active');
        }

        // Remove active class from all indicators
        for (let k = 0; k < l; k++) {
            $(`#${slides[k].item}`).removeClass('active');
        }

        // Add active class on current text div
        $(`#${slides[activeIndex].div_id}`).addClass('active');

        // Add active class on current indicator
        $(`#${slides[activeIndex].item}`).addClass('active');
    };

    const initializeDesktopCarousels = function (slides, iPhoneCarouselId, AndroidCarouselId) {
        for (let i = 0, l = slides.length; i < l; i++) {
            $(`#${slides[i].item}`).click(() => {
                moveCarousels(i, iPhoneCarouselId, AndroidCarouselId);
                setActiveDiv(slides, i);
            });
            $(`#${slides[i].div_id}`).click(() => {
                moveCarousels(i, iPhoneCarouselId, AndroidCarouselId);
                setActiveDiv(slides, i);
            });
        }
    };

    // First carousel Desktop
    const carouselSlides1 = [
        {
            item: 'carousel-desktop-0',
            div_id: 'show-discover'
        },
        {
            item: 'carousel-desktop-1',
            div_id: 'show-search'
        },
        {
            item: 'carousel-desktop-2',
            div_id: 'show-home'
        }
    ];

    initializeDesktopCarousels(carouselSlides1, '#carousel-desktop-left-1', '#carousel-desktop-left-2');

    // Second carousel Desktop
    const carouselSlides2 = [
        {
            item: 'carousel-desktop-3',
            div_id: 'show-exchange'
        },
        {
            item: 'carousel-desktop-4',
            div_id: 'show-trip'
        },
        {
            item: 'carousel-desktop-5',
            div_id: 'show-travel'
        }
    ];

    initializeDesktopCarousels(carouselSlides2, '#carousel-desktop-right-1', '#carousel-desktop-right-2');

    // Smartphone carousels
    const $iosCarousel = $('#ios-carousel');
    const $androidCarousel = $('#android-carousel');
    const $descriptionCarousel = $('#description-carousel');
    const $leftButtonCarousel = $('.smartphone-details-block .carousel-control.left');
    const $rightButtonCarousel = $('.smartphone-details-block .carousel-control.right');
    const $indicators = $('.smartphone-details-block .carousel-indicators li');

    // Link carousels together: when the description changes, the others change too
    $descriptionCarousel.on('slide.bs.carousel', (e) => {
        const $target = $(e.relatedTarget);
        const index = $target.index();

        // Update phone carousels
        $iosCarousel.carousel(index);
        $androidCarousel.carousel(index);

        // Update indicators
        $indicators.removeClass('active');
        $indicators.eq(index).addClass('active');
    });

    // Handle previous/next buttons
    $leftButtonCarousel.click(() => {
        $descriptionCarousel.carousel('prev');
    });

    $rightButtonCarousel.click(() => {
        $descriptionCarousel.carousel('next');
    });

    // Handle indicators
    $indicators.click((e) => {
        $descriptionCarousel.carousel($(e.currentTarget).data('slide-to'));
    });

    // User Agent context
    if ($.ua.os.name === 'Android') {
        $('#page-app').addClass('android');
    } else if ($.ua.os.name === 'iOS') {
        $('#page-app').addClass('ios');
    }
});
